export const phrases = {
  heading_settings_sort: "Ordinamento dell'elenco del personale",
  body_settings_sort: "Ordinare l'elenco del personale per nome o cognome.",
  since_o_clock: "Dal momento che l'orologio {time}",
  old_data_warning_my_area: "Non è stato possibile caricare nuove informazioni. Assicuratevi di essere connessi a Internet.",
  no_data_warning_my_area: "Assicurarsi di essere connessi a Internet e riprovare.",
  no_data_available_my_area: "Non è possibile caricare i dati",
  last_update_data: "Ultimo aggiornamento",
  something_went_wrong_absences: "Qualcosa è andato storto. Riprovare in un secondo momento.",
  something_went_wrong_with_the_pin_entry: "Qualcosa è andato storto con l'inserimento del PIN...",
  pin_must_be_four_digits: "Il PIN deve essere composto esattamente da quattro cifre.",
  pins_do_not_match: "I PIN inseriti non corrispondono.",
  pin_is_not_numerical: "Il PIN può essere composto solo da numeri.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Timbrare",
  finish_break: "Fine pausa",
  finish_loading_time: "Tempo di caricamento finale",
  finish_driving_time: "Fine del tempo di guida",
  finish_business_trip: "Fine del turno di servizio",
  finish_project_as_task: "Terminare il progetto",
  finish_special_one: "Fine Speciale1",
  finish_special_two: "Fine Speciale2",
  you_clockout: "Ti sei imposto di uscire",
  sentence_work_time: "Stai lavorando. | Stai lavorando in questo momento.",
  sentence_break: "Stai facendo una pausa. | Ti stai prendendo una pausa.",
  sentence_loading_time: "Si sta registrando il tempo di caricamento. Hauruck! | Si sta registrando il tempo di caricamento. Stupido!",
  sentence_business_trip: "Servizio connesso. Divertitevi!",
  sentence_driving_time: "State prenotando il tempo di guida. Allacciate le cinture e partite! | Stai prenotando il tempo di viaggio. Allacciate le cinture e partite!",
  sentence_special_one: "Stai prenotando lo Speciale 1. | Stai prenotando lo speciale 1.",
  sentence_special_two: "Stai prenotando lo Speciale 2. | Stai prenotando lo speciale 2.",
  sentence_custom_time: "Stai prenotando | Stai prenotando",
  you_are_booked_in_activity: "Timbra {activity}! | Timbro {activity}!",
  substitute_warning: "{ days } Per le assenze di giorni o più deve essere nominato un sostituto.",
  substituted_by: "Rappresentato da",
  name_clocked_in: "{name} timbrato",
  /************************************/
  //Signature stuff:

  signature: "Firma",
  please_sign: "Si prega di firmare",
  signature_with_date: "Firma di {date}",
  signature_with_date_with_name: "Firma di {date} da {name}",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "Firma di {date} da {name} in {location}",
  signature_with_name: "Firma di {name}",
  signature_with_name_with_location: "Firma di {name} in {location}",
  signature_with_location: "Firma in {location}",
  /*************************************/

  accept_terms_and_conditions: "Inviando il modulo si accettano il nostro {agb} e il nostro {datenschutzerklaerung}.",
  what_is_your_name: "Come ti chiami?",
  your_email: "Il vostro indirizzo e-mail",
  what_is_your_company_name: "Qual è il nome della vostra azienda?",
  what_do_you_want_to_do_with_clockin: "Cosa vuoi fare con l'orologio?",
  almost_finished: "Ci siamo quasi",
  test_clockin_for_amount_period: "Testate gratuitamente il clockin {amountOfDaysTestPeriod} per alcuni giorni!",
  code_needed_to_connect: "Utilizza il tuo codice",
  you_have_no_company_code: "Non avete un codice? Contattate la persona che fa parte della vostra azienda.",
  connect_your_device: "Collegare il dispositivo!",
  please_type_in_device_id: "Inserire l'ID del dispositivo, che si trova alla voce dispositivi mobili del nostro sito web.",
  new_at_clockin: "Nuovo per quanto riguarda il cronometraggio?",
  pin_repeat: "Ripetere il PIN",
  configure_your_pin: "Impostare il PIN a 4 cifre",
  configure_your_pin_text: "Il PIN è necessario per accedere alla propria area personale sul terminale tablet.",
  congratulations: "Congratulazioni!",
  start_now: "Inizia subito",
  device_name_info: "È possibile modificare il nome del dispositivo mobile in modo da tenere traccia di più dispositivi. Esempio: \"Smartphone MaxMustermann\". Il nome può essere modificato anche in un secondo momento.",
  select_project: "Selezionare il progetto",
  select_time: "Ora selezionata",
  create_new_account: "Creare un nuovo account",
  join_my_company: "Unisciti alla mia azienda",
  join_clockin_with_qr: "Iscriviti con il codice QR",
  change_project: "Progetto di cambiamento",
  my_messages: "Le mie notizie",
  my_documents: "I miei documenti",
  my_data_and_passwords: "I miei dati e le mie password",
  my_account_data: "I miei dati",
  change_my_password: "Modifica della password",
  forgot_password: "Non conosco la mia password.",
  open_camera: "Telecamera aperta",
  scan_now: "Scansione ora",
  sync_now: "Sincronizza ora",
  clear_logs: "Tronchi vuoti",
  saveAndGoBack: "Salvare e restituire",
  full_day: "Giornata intera",
  activate_scanner: "Lo scanner è attivato",
  scanner_is_inactive: "Scanner inattivo",
  change_project_by_scan_qr: "Scansionare il codice QR del progetto a cui si vuole passare.",
  scan_device_by_qr: "Scansionare il codice QR dal dispositivo che si desidera utilizzare.",
  no_access_to_camera_please_connect_device_manually: "Purtroppo non è stato possibile accedere alla fotocamera, si prega di inserire manualmente il codice del dispositivo.",
  no_access_to_camera_please_clockin_manually: "Purtroppo non è stato possibile accedere alla telecamera, si prega di timbrare manualmente.",
  qr_code_login: "Registrazione con codice QR",
  scan_to_login: "Scansionate il vostro codice QR per accedere.",
  checklist_was_saved: "La lista di controllo è stata salvata",
  question_save_changes_short: "Salvare le modifiche?",
  question_save_changes: "Volete salvare le modifiche?",
  question_delete_checklist_short: "Cancellare la lista di controllo?",
  question_delete_checklist: "Siete sicuri di voler eliminare la lista di controllo?",
  checklist_is_sending: "Verrà inviata una lista di controllo",
  checklist_sent_successfully: "Elenco di controllo inviato con successo 🎉",
  checklist_could_not_be_sent: "Impossibile inviare l'elenco di controllo, riprovare più tardi.",
  checklist_transmission_problems_in_the_past: "In passato, si sono verificati problemi di trasferimento con alcuni file.",
  checklist_send_with_potential_data_loss: "Vuoi provare a inviare la checklist senza questi file?",
  documentation_is_sending: "Invio della documentazione del progetto",
  documentation_sent_successfully: "Documentazione del progetto inviata con successo 🎉",
  confirm_documentation_dismissal: "Volete davvero scartare la documentazione?",
  discard_unsaved_changes: "Vuoi scartare i tuoi cambiamenti?",
  documentation_will_be_sent_when_online: "La documentazione verrà inviata non appena sarete nuovamente online.",
  confirmation_is_sending: "Viene inviata la conferma del progetto",
  ask_for_geo_permission: "Questa applicazione ha bisogno della vostra posizione, " + "ma non ha il permesso di farlo.\n\n" + "Volete aprire le impostazioni?",
  all_projects: "Tutti i progetti",
  half_day: "Mezza giornata",
  start_end: "In base al tempo",
  my_area: "La mia zona",
  my_area_video_teaser_clockin_explained_by_frederik: "clockin spiegato da Freddi",
  add_time: "Creare tempo",
  show_times_in_confirmation: "Orari degli spettacoli in conferma",
  change_time: "Tempo di modifica",
  finish_project: "Progetto completo",
  finish_project_date: "Finalizzare la nomina",
  unfinish_project: "Riaprire il progetto",
  unfinish_project_date: "Riaprire l'appuntamento",
  absence_overview: "Gestire le assenze",
  edit_absence: "Modifica assenza",
  edited_absence: "Assenza modificata",
  created_absence: "Richiesta di congedo creata con successo",
  creating_absence: "La richiesta di congedo è stata creata",
  error_creating_absence: "Errore durante la creazione della richiesta di assenza",
  create_absence: "Creare l'assenza",
  deleted_absence: "Richiesta di assenza ritirata",
  new_request: "Nuova applicazione",
  your_requests: "Le vostre applicazioni",
  planned_days: "Giorni programmati",
  planned_hours: "Orari programmati",
  used_days: "Giorni di utilizzo",
  used_hours: "Ore trascorse",
  free_days: "Giorni di riposo",
  free_hours: "Orari di vacanza",
  open_days: "Giorni di apertura",
  open_hours: "Orari di apertura",
  withdraw_request: "Ritiro della domanda",
  change_request: "Richiesta di modifica",
  request_was_approved: "La vostra domanda è stata approvata",
  request_is_pending: "La vostra domanda non è ancora stata approvata",
  request_was_rejected: "La domanda è stata respinta",
  add_attachment: "Aggiungi allegato",
  message_optional: "Messaggio (opzionale)",
  filed_on: "Presentato il",
  this_year: "Quest'anno",
  search_sub_projects: "Su quale sottoprogetto vorresti lavorare?",
  error_occurred: "Si è verificato un errore, riprovare più tardi.",
  re_record: "Cancellare e riregistrare questo video?",
  delete_video: "Cancellare la registrazione?",
  no_results_found: "Nessun risultato trovato",
  record_again: "Ripetere",
  request_valid_email: "Inserire un indirizzo e-mail valido.",
  request_valid_company_name: "Inserire un nome di azienda valido.",
  request_valid_first_name: "Inserire un nome valido.",
  request_valid_last_name: "Inserire un cognome valido.",
  total_duration_today: "Tempo totale oggi",
  show_daily_protocol: "Mostra il registro giornaliero",
  change_profile_pic: "Modifica dell'immagine del profilo",
  logout_account: "Disconnettere l'account",
  you_are_working: "State lavorando in questo momento!",
  you_are_taking_a_break: "Sei in pausa!",
  activity_edited: "Attività modificata",
  activity_edited_undo: "Elaborazione annullata con successo",
  activity_edited_missing_project: "Oh, il progetto manca ancora!",
  activity_deleted: "Attività cancellata",
  activity_deleted_undo: "Ripristino dell'attività cancellata",
  activity_created: "Nuova attività creata",
  activity_created_undo: "Attività appena creata ritirata",
  correct_working_hours: "Tempi di lavoro corretti",
  your_changes_are_being_saved: "Le modifiche sono state salvate.",
  manage_working_hours: "Gestire gli orari di lavoro",
  delete_activity: "Cancellare l'attività",
  start_navigation: "Avviare la navigazione",
  no_valid_email: "L'indirizzo e-mail inserito non è valido.",
  delete_checklist: "Cancellare la lista di controllo",
  active_checklists: "Liste di controllo attive",
  scan_qr_code: "Scansione del codice QR",
  switch_to_office_center: "Passare al centro uffici",
  confirm_project_completion_short: "Progetto completo",
  confirm_project_date_completion_short: "Finalizzare la nomina",
  project_completed: "Progetto completato!",
  project_date_completed: "Appuntamento concluso!",
  confirm_project_uncompletion_short: "Riaprire il progetto",
  confirm_project_date_uncompletion_short: "Riaprire l'appuntamento",
  project_uncompleted: "Progetto attivato",
  project_date_uncompleted: "Data di attivazione",
  choose_project: "Selezionare il progetto",
  choose_sub_project: "Selezionare il sottoprogetto",
  choose_site: "Selezionare la posizione",
  active_projects: "Progetti attivi",
  completed_term: "completato",
  completed_projects: "Progetti completati",
  end_of_work: "Buona serata",
  correct_time: "Tempo corretto",
  you_stamp_x: "Timbro",
  enter_pin: "Inserire il PIN",
  wrong_pin: "Inserimento errato del PIN",
  pin_change_required: "È stato richiesto di modificare il PIN",
  enter_new_pin: "Inserire il nuovo PIN",
  approve_pin: "Confermare il PIN",
  no_projects_scheduled: "Per {day} Non viene memorizzato alcun progetto.",
  you_clock_in_project: "D'ora in poi registrerete il tempo di lavoro del progetto.",
  project_scan_error: "Questo codice non è valido per nessun progetto.",
  show_more_days: "mostra più giorni",
  show_more_times: "Mostra più volte",
  only_show_today: "Mostra solo oggi",
  todays_total_time: "Tempo totale oggi",
  everything_synced: "I vostri dati sono aggiornati!",
  upload_in_progress: "I dati vengono caricati...",
  who_are_you: "Chi sei?",
  is_uploading_to_server: "Le modifiche apportate vengono trasferite al centro ufficio.",
  offline_and_data_is_stored_locally: "Le vostre modifiche saranno presto trasferite al centro uffici. ",
  show_more: "Mostra di più",
  activity_edited_wrong_date: "È stata inserita la data sbagliata.",
  confirm_logout: "Vuoi davvero annullare l'iscrizione?",
  confirm_clockout: "Sei sicuro di voler timbrare il cartellino per oggi?",
  gps_is_active: "I dati GPS vengono trasmessi",
  location_tracking_is_active: "Per attivare la localizzazione GPS.",
  app_settings: "Impostazioni dell'app",
  clock_reminder: "Timbro - Promemoria",
  mon_to_fri: "Standard: lunedì - venerdì",
  logout: "Disconnettere l'account",
  refresh: "Aggiornamento",
  prompt_language_settings: "Impostare qui la lingua dell'applicazione.",
  prompt_clock_reminder: "Promemoria tramite notifica push per adattarsi al tuo lavoro quotidiano.",
  register_company: "Registrazione dell'azienda",
  use_code: "Utilizzare il codice",
  our_customers: "I nostri clienti",
  free_test_now: "Il test è ora gratuito",
  tier_attendance: "Registro solo le ore di lavoro e le pause.",
  tier_documentation: "Voglio anche prenotare le ore di lavoro sui progetti che gestisco in clockin.",
  your_tier: "Il vostro pacchetto",
  all_clockin_functions: "Tutte le funzioni di clockin",
  checklists_formulars: "Liste di controllo e funzioni",
  projectfile_incl_chat: "File digitali del progetto (inclusa la chat)",
  photo_sketch_note: "Funzione foto, schizzi e note",
  digital_signature: "Firme digitali",
  datev_connection: "Connessione DATEV",
  calendar_absences: "Gestione del calendario e delle assenze",
  individual_design: "Aspetto individuale",
  attendance_time_tracking: "Registrazione dei tempi di stazionamento tramite terminale tablet",
  mobile_time_tracking: "Registrazione mobile del tempo tramite l'applicazione per smartphone",
  browser_time_tracking: "Registrazione del tempo del browser sul PC per l'ufficio a casa",
  help_use_code: "Inserite il codice che trovate nel centro ufficio alla voce dispositivi mobili/dipendenti.",
  wrong_code: "Codice sbagliato",
  wrong_code_text: "Il codice non è valido. Riprovare con un codice valido",
  wrong_code_text_short: "Il codice non è valido",
  clockin_logo: 'Clockin Logo',
  invalid_qr_code: "Codice QR non valido",
  invalid_qr_code_text: "Il codice QR scansionato non è valido. Si prega di scansionare un codice di timbratura valido.",
  code_already_connected: "Con questo codice è possibile collegare il dispositivo. Ma siete già connessi.",
  wrong_credentials: "Dati di accesso non corretti",
  wrong_credentials_text: "La combinazione di e-mail e password inserita non è stata trovata. Si prega di controllare l'inserimento e riprovare.",
  new_pin: "Inserire il nuovo PIN",
  choose_next_action: "Scegliere la prossima azione",
  name_of_software_package: "Nome del pacchetto software",
  select_teamleader: "Chi timbra per la squadra?",
  select_teamleader_description: "Per continuare le attività di timbratura, selezionare una persona che prenda in consegna la macchina.",
  clocked_in_on_this_device: "Stampato su questa unità",
  not_clocked_in_on_this_device: "Non stampigliato su questa unità",
  select_new_teamleader: "Chi dovrebbe timbrare per la squadra ora?",
  switch_teamleader: "Consegna dell'unità",
  just_me: "Ho appena timbrato il cartellino",
  select_the_new_teamleader: "Determinare il nuovo team leader",
  back_to_selection: "torna alla selezione",
  manage_team: "Gestire il team",
  total_time_team: "Tempo totale del team",
  count_members_clocked_in: "{clockedin}/{members} Membri del team timbrati in",
  whole_team: "Tutto il team",
  teammembers_still_clockedin: "Scegliete se volete timbrare il cartellino solo voi o tutti i membri del team?",
  clockout_all: "Eliminare tutti i",
  select_employee: "Selezionare prima un utente",
  something_went_wrong: "Qualcosa è andato storto, riprovare più tardi.",
  new_pin_successfully_changed: "Il PIN è stato modificato con successo",
  enter_pin_before_clockin_prompt: "Per prima cosa, inserire il PIN uno alla volta per effettuare l'accesso.",
  enter_pin_before_clockout_prompt: "Per prima cosa inserire il PIN, uno alla volta, per timbrare il cartellino.",
  delete_activity_alert_title: "Cancellare l'attività",
  delete_activity_alert_msg: "Siete sicuri di voler eliminare l'attività?",
  delete_absence_message: "È sicuro di voler ritirare la domanda?",
  delete_absence_title: "Ritiro della domanda",
  are_you_sure: "Sei sicuro?",
  request_password: "Richiesta di una nuova password",
  password_requested: "Il link per una nuova password è stato inviato al vostro indirizzo e-mail.",
  no_email_retrieved: "Non avete ricevuto l'e-mail? Controllare la cartella spam o riprovare.",
  name_of_customer: "Nome del cliente",
  missing_permissions_homepage_text: "L'utente non è autorizzato a modificare la propria attività su questo computer. Contattare l'amministratore per ottenere l'accesso.",
  no_permission_warning_my_area: "Non siete autorizzati ad accedere a quest'area. Contattare l'amministratore per ottenere l'accesso.",
  employee_clocked_in: "{name} registrati!",
  employee_clocked_out: "{name} disconnesso!",
  no_employee_to_qr_code_warning: "Non è stato possibile trovare alcun dipendente per questo codice QR.",
  no_employees_registered_heading: "Non è stato ancora assegnato alcun personale a questa unità.",
  no_employees_registered_body: "Nel centro ufficio, nelle impostazioni del dispositivo mobile, è possibile assegnare i dipendenti che sono poi autorizzati a registrare i loro tempi su questo dispositivo.",
  no_employee_found: "Purtroppo non è stato possibile trovare nessuno con questo nome.",
  no_employee_assigned: "Nessun dipendente assegnato",
  you_need_help: "Hai bisogno di aiuto?",
  here_you_can_get_help_to_register_employees_for_device: "Qui troverete tutte le informazioni su come assegnare il personale a un'unità.",
  show_time: "Creare tempo",
  export_timesheet: "Esportazione del timesheet",
  select_month: "Selezionare il mese",
  internet_connection_required: "A tal fine è necessaria una connessione a Internet.",
  select_an_activity_to_clockin_your_team: "Selezionate un'attività da timbrare nel vostro team.",
  confirm_uploading_sqlite_for_debugging: "Sei sicuro di voler caricare i dati nell'app per il supporto di Clockin?",
  no_tasks_available: "Nessun compito disponibile",
  click_to_add_tasks: "Clicca per aggiungere compiti",
  scan_nfc_tag: "Si prega di avvicinare la carta al lettore.",
  link_nfc_tag: "Collegare il tag NFC",
  select_employee_for_nfc_tag: "Seleziona un dipendente per collegare questo tag NFC:",
  nfc_tag_linked_successfully: "Tag NFC con successo con {name} collegato.",
  nfc_linking_failed: "Impossibile collegare il tag NFC. Riprova.",
  nfc_not_enabled: "NFC non è supportato da questo dispositivo o è disabilitato.",
  nfc_initialization_failed: "Purtroppo, qualcosa è andato storto. Riprova.",
  nfc_scan_failed: "Purtroppo, qualcosa è andato storto. Riprova.",
  nfc_no_tag_found: "Non è stato trovato alcun tag NFC.",
  nfc_tag_already_linked_to: "Questo tag NFC è già disponibile con {name} collegato.",
  nfc_scan_active: "Scansione NFC attiva",
  nfc_linking_enabled: "I tag NFC possono ora essere collegati. Si prega di tenere premuto il tag NFC per collegarlo al lettore NFC ora.",
  nfc_all_employees_linked: "Tutti i dipendenti assegnati a questo dispositivo sono già stati collegati.",
  no_employee_to_nfc_warning: "Non è stato possibile trovare alcun dipendente per questo tag NFC.",
  select_employee_to_link_nfc: "A chi deve essere collegato il tag NFC?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Benvenuti a Clockin",
        clocking_time: "Tempi in pista",
        push_notifications: "Non dimenticare nulla"
      },
      text: {
        clocking_time: "Il clocker è il punto di partenza per ogni attività. Tu ti occupi del tuo lavoro, l'app si occupa della documentazione.",
        push_notifications: "Ora attiva le notifiche. Clockin ti ricorda se dimentichi un timbro e si assicura di prendere subito tutto ciò che è importante."
      },
      button: {
        lets_go: "Inizia subito"
      }
    },
    my_area: {
      heading: {
        my_area: "La mia zona",
        absences: "Assenze e applicazioni",
        settings: "Impostazioni personali"
      },
      text: {
        my_area: "Il luogo centrale in cui avete una panoramica immediata delle vostre ore di lavoro e degli straordinari. Da qui potete gestire il vostro orario di lavoro, accedere al vostro registro giornaliero, presentare richieste e visualizzare i vostri orari.",
        absences: "Gestite le richieste di ferie, giorni di malattia e altre assenze. Tenete sempre sotto controllo lo stato delle vostre richieste e inviatene di nuove in modo rapido e semplice con pochi clic.",
        settings: "Inviate messaggi all'azienda o modificate le vostre impostazioni personali e se volete cambiare la vostra password, potete farlo anche qui!"
      },
      button: {
        lets_go: "Inizia"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Perché il vostro tempo conta",
        clock_in: "Timbro in",
        switch_task: "Modifica del timbro",
        clock_out: "Timbrare",
        thats_it: "Ecco fatto!"
      },
      text: {
        your_time_matters: "Con il clockin vi aiutiamo a concentrarvi sull'essenziale. Registrate il vostro tempo di lavoro con un solo clic.",
        clock_in: "Con un solo clic si viene registrati direttamente. Clockin salva automaticamente i dati e consente di avere sempre tutto sotto controllo.",
        switch_task: "Avete un altro progetto, state facendo una pausa o state andando al vostro prossimo appuntamento? È sufficiente timbrare nuovamente la nuova attività. Il resto viene registrato automaticamente.",
        clock_out: "E con un solo clic si è eliminati.",
        thats_it: "L'avete fatto e siete pronti a registrare il vostro tempo di lavoro. Se avete bisogno di aiuto, contattateci. Con il clockin tutto è facile, anche comunicare con noi."
      },
      button: {
        your_time_matters: "Mostrami come si fa",
        thats_it: "Inizia subito"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Perché il vostro tempo conta",
        clock_in: "Timbro in",
        clock_in_team: "Team di check-in",
        switch_task: "Modifica del timbro",
        change_teamleader: "Consegna dell'unità",
        clock_out: "Timbrare",
        thats_it: "Ecco fatto!"
      },
      text: {
        your_time_matters: "Con clockin vi aiutiamo a concentrarvi sull'essenziale. Registrate le ore di lavoro del vostro team con un solo clic.",
        clock_in: "Selezionate una persona che timbra il cartellino per il team e, con un solo clic, sarete registrati direttamente. clockin salva automaticamente i dati e voi potete tenere sempre sotto controllo tutto.",
        clock_in_team: "Basta timbrare direttamente il vostro team. Sia tutti insieme che i singoli membri.",
        switch_task: "Avete un altro progetto, vi state prendendo una pausa o state viaggiando verso il vostro prossimo appuntamento? Basta timbrare la nuova attività. Il resto verrà registrato automaticamente.",
        change_teamleader: "State finendo di lavorare, dovete andarvene o non timbrate più il cartellino per il team? Basta consegnare il dispositivo nell'app e tutto torna alla normalità.",
        clock_out: "Con un solo clic, voi e il vostro team avrete timbrato il cartellino. Naturalmente, è possibile timbrare il cartellino anche ai singoli membri in qualsiasi momento.",
        thats_it: "Avete finito e siete pronti a registrare l'orario di lavoro del vostro team. Se avete bisogno di aiuto, contattateci. Con clockin tutto è facile, anche comunicare con noi."
      },
      button: {
        your_time_matters: "Mostrami come si fa",
        thats_it: "Inizia subito"
      }
    },
    my_area: {
      heading: {
        welcome: "Benvenuti nella vostra zona",
        my_area: "La mia zona",
        create_time: "Creare tempo",
        change_time: "Tempo corretto",
        absences: "Assenze e applicazioni",
        settings: "Impostazioni personali",
        thats_it: "Ecco fatto!"
      },
      text: {
        welcome: "Scoprite altri modi per gestire il vostro tempo di lavoro in modo semplice ed efficiente. Diamo un'occhiata alla vostra area.",
        my_area: "Il luogo centrale in cui avete una panoramica immediata delle vostre ore di lavoro e degli straordinari. Da qui potete gestire il vostro orario di lavoro, accedere al vostro registro giornaliero, presentare richieste e visualizzare i vostri orari.",
        create_time: "Avete dimenticato di inserire un orario o volete aggiungerlo in seguito? Nessun problema! Aggiungete le ore mancanti, registrate le pause e tenete aggiornato il vostro conto delle ore di lavoro.",
        change_time: "Volete correggere i vostri tempi? Nessun problema! Con clockin potete facilmente correggere e aggiustare i tempi sbagliati.",
        absences: "Gestite le richieste di ferie, giorni di malattia e altre assenze. Tenete sempre sotto controllo lo stato delle vostre richieste e inviatene di nuove in modo rapido e semplice con pochi clic.",
        settings: "Inviate messaggi all'azienda o modificate le vostre impostazioni personali e se volete cambiare la vostra password, potete farlo anche qui!",
        thats_it: "Ce l'avete fatta! Ora potete gestire senza problemi il vostro tempo, organizzare le assenze e concentrarvi su ciò che è importante: il vostro lavoro. Buona fortuna con il vostro tempo produttivo!"
      },
      button: {
        welcome: "Mostrami come si fa",
        thats_it: "Inizia subito"
      }
    },
    clock: {
      clockin_now: "Bloccate ora",
      clock_your_first_time_now: "e registrare la prima volta"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Grazie per aver utilizzato clockin!",
      question: "Quanto è probabile che raccomandiate clockin ad amici o colleghi?",
      very_likely: "Molto probabile",
      very_unlikely: "Molto improbabile",
      help_us_improve: "Come possiamo migliorare il clockin per voi?",
      what_do_you_agree_with: "Con quali affermazioni è d'accordo?",
      choose_three_statements: "Scegliete fino a tre affermazioni.",
      hard_to_use: "Difficile da usare",
      lacking_features: "Troppo poche funzioni",
      does_not_help_me: "non facilita la mia giornata lavorativa",
      confusing: "confuso",
      poorly_implemented: "Funzioni mal implementate",
      too_buggy: "troppo soggetto a errori",
      too_slow: "lunghi tempi di caricamento",
      what_else: "C'è qualcos'altro che vorrebbe dirci?",
      can_we_ask_you_a_few_questions: "Possiamo farle qualche altra domanda?",
      how_happy_are_you_with_the_introduction_of_clockin: "Quanto siete soddisfatti dell'introduzione del clockin nella vostra azienda?",
      how_much_do_you_enjoy_using_clockin: "Ti piace usare clockin?",
      how_much_easier_does_clockin_make_your_work: "Quanto facilita il lavoro quotidiano il timbrare il cartellino?",
      how_happy_are_you_with_the_following_aspects: "Quanto è soddisfatto dei seguenti punti?",
      clarity_of_the_app: "Chiarezza dell'applicazione",
      simplicity_of_use: "Semplicità di funzionamento",
      app_features: "Funzioni nell'app",
      feedback_received: "Il vostro feedback è stato ricevuto. Grazie per averci dedicato del tempo.",
      thanks_for_taking_the_time: "Grazie per averci dedicato del tempo.",
      what_can_we_do_to_improve: "Può raccontarci qualcosa di più sulla sua esperienza, in modo da poter fare ancora meglio la prossima volta?",
      what_can_we_do_to_get_it_right: "Può raccontarci la sua esperienza in modo che la prossima volta possiamo fare le cose per bene?",
      comment_placeholder: "Il vostro messaggio"
    }
  },
  travel_logs: {
    add: "Aggiungere i dettagli del viaggio",
    edit: "Modifica dei dettagli del viaggio",
    saving: "I dettagli del viaggio vengono salvati...",
    saved_successfully: "Dettagli del viaggio salvati con successo!",
    unable_to_save: "Purtroppo, non ha funzionato 😢"
  },
  attach_file: "Allegare il file",
  image_to_text: {
    info: "Assicuratevi che il testo sia chiaramente riconoscibile e che sia visibile per intero sull'immagine.",
    attach_image: "Allegare l'immagine",
    processing: "Il testo verrà letto in.",
    processing_failed: "Purtroppo, l'importazione non ha funzionato 😢",
    no_text_found: "Non è stato possibile riconoscere alcun testo."
  },
  correction_enter_reason: "Si prega di fornire un motivo per la correzione.",
  daily_notes: {
    add: "Scrivere una nota",
    edit: "Nota di modifica",
    saving: "La nota viene salvata...",
    saved_successfully: "Nota salvata con successo!",
    unable_to_save: "Purtroppo, non ha funzionato 😢",
    no_notes_yet: "Nessuna nota creata",
    create_note: "Creare"
  },
  calendar_sync: {
    title: "Sincronizza pianificazione",
    description: "Sincronizzate il vostro programma di lavoro con un calendario e tenete d'occhio gli appuntamenti vecchi e nuovi.",
    url: "Indirizzo in formato iCal",
    url_description: "È possibile utilizzare questo indirizzo per accedere al calendario da altre applicazioni.",
    note: "Nota",
    note_description: "In alcuni calendari possono essere necessarie fino a 24 ore per visualizzare i nuovi appuntamenti.",
    sync_now: "Sincronizzare il calendario",
    copied: "L'url del calendario è stato copiato."
  },
  registration: {
    skip_all: "Salta tutto",
    already_signed_up: "Ho già un account",
    title_1: "Iniziamo! Quali orari vorresti registrare con il clockin?",
    description_1: "Personalizziamo l'orologio per voi",
    option_1_a: "Orario di lavoro generale (entrata, uscita e pausa)",
    option_1_b: "Orario di lavoro del progetto",
    title_2: "Volete documentare?",
    description_2: "Quali requisiti devono essere soddisfatti per questo?",
    option_2_a: "Foto",
    option_2_b: "Schizzi",
    option_2_c: "Nota funzione",
    option_2_d: "Liste di controllo e moduli",
    option_2_e: "File digitali del progetto",
    title_3: "Cos'altro vorreste digitalizzare?",
    description_3: "C'è molto altro da scoprire a clockin, forse c'è qualcosa per voi.",
    option_3_a: "Vacanze",
    option_3_b: "Malattie e assenze",
    option_3_c: "Fascicolo personale digitale",
    option_3_d: "Analisi dell'azienda",
    option_3_e: "Pianificazione della distribuzione",
    option_3_f: "Consulente fiscale per il trasferimento dei dati (DATEV)",
    title_4: "In quale settore opera la vostra azienda?",
    description_4: "Vogliamo conoscervi meglio per poter adattare il clockin alle vostre esigenze.",
    option_4_a: "servizi",
    option_4_b: "Artigianato",
    option_4_c: "Salute e benessere",
    option_4_d: "Acquisti, ordini e commercio",
    option_4_e: "Hotel e ristorazione",
    option_4_f: "Auto, trasporti e macchinari",
    option_4_g: "Altro settore",
    title_5: "Quanti sono i dipendenti della vostra azienda?",
    description_5: "Con il numero di dipendenti, possiamo personalizzare il clockin in base alle dimensioni della vostra azienda.",
    title_6: "Super! Il tuo orologio è ora impostato",
    description_6: "Ci serve solo il suo nome.",
    input_6_a: "Azienda",
    input_6_b: "Nome",
    input_6_c: "Cognome",
    input_6_d: "Numero di telefono",
    title_7: "Siete pronti a partire! Prova clockin 14 giorni gratis!",
    input_7_a: "Il vostro indirizzo e-mail",
    description_7: "A quale indirizzo e-mail dobbiamo inviare la password?",
    input_7_b: "È così che mi sono reso conto",
    how_did_you_hear_about_clockin: "Come ha sentito parlare per la prima volta di clockin?",
    recommendation_option_1: "Raccomandazione",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Ricerca su Internet",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Piattaforma di confronto",
    recommendation_option_7: "Riviste e articoli online",
    known_from: "Conosciuto da",
    agb_1: "Inviando il modulo, si accettano le ",
    agb_2: 'AGB',
    agb_3: " e il ",
    agb_4: "Informativa sulla privacy",
    start: "Avvio del test",
    validation_failed: "Compilare correttamente tutti i campi."
  },
  clocki: {
    listening_heading: "Ti sto ascoltando",
    listening_subtext: "come posso aiutarti?",
    hi_0: "Salve, come posso aiutarla?",
    hi_1: "Ehi, come posso aiutarvi?",
    hi_2: "Salve, come posso aiutarla?",
    hi_3: "Moin moin, cosa posso fare per voi?",
    hi_4: "Salve, cosa posso fare per voi?",
    hi_5: "Salve, come posso aiutarla?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Purtroppo il riconoscimento vocale non sembra funzionare sul vostro dispositivo.",
    microphone_permission_denied: "Purtroppo non ho accesso al suo microfono. La prego di controllare le autorizzazioni nelle impostazioni in modo che possa sentirla.",
    please_speak: "Ora è possibile parlare con Clocki",
    create_activity: "Creare un'attività",
    modify_activity: "Cambia attività",
    delete_activity: "Eliminare l'attività",
    create_daily_note: "Crea una nota giornaliera",
    search_project: "Cerca un progetto",
    note_copied: "Nota copiata",
    create_absence_request: "Richiedi assenza",
    delete_absence: "Cancellare l'assenza",
    confirm_deletion: "Sei sicuro che il tuo {activity_label} Stampaggio da {date} l'orologio dovrebbe essere cancellato?",
    confirm_absence_deletion: "Sei sicuro che la tua richiesta di {category} dal {startDate} fino a {endDate} Vuoi eliminare?",
    task_before_modification: "Prima: {task}",
    starts_at_before_modification: "Orario di inizio prima: {startsAt}",
    ends_at_before_modification: "Ora di fine prima: {endsAt}",
    something_went_wrong: "Qualcosa è andato storto, riprovi più tardi.",
    was_this_helpful: "Clocki potrebbe aiutarti?",
    actions: {
      CREATE_ABSENCE: {
        title: "Confermare l'assenza"
      },
      CREATE_DAILY_NOTE: {
        title: "Crea subito una nota",
        daily_notes_disabled: "Purtroppo la funzione note è disattivata. Chiedete all'amministratore di attivare la funzione nel centro ufficio.",
        success: "Nota salvata con successo nel registro giornaliero 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Creare subito la documentazione",
        created_by_clocki: "Creato con Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Aprire ora \"I miei tempi"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Aprire ora \"La mia area\"."
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Aprire ora \"Modifica password\"."
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Timbro \"orario di lavoro\" ora",
        PAUSE: "Timbro \"Pausa\" ora",
        DRIVING_TIME: "Timbro \"tempo di viaggio\" ora",
        LOGOUT: "Sblocca ora"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Ti piace usare Clockin?"
  },
  translation_failed: "Purtroppo, la traduzione non ha funzionato 😕",
  video_transcript_not_available: "Nessuna trascrizione disponibile",
  video_upload_succeeded: "Caricamento video completato.",
  video_upload_failed: "Upload video fallito.",
  video_send_failed: "Il video non poteva essere trasmesso al momento. Riproveremo più tardi.",
  uploading_video: "Caricamento video...",
  language_selection_header: "Seleziona lingua",
  language_selection_message: "Scegli la lingua che preferisci",
  shifts: {
    my_shifts: "I miei turni",
    free_shifts: "Turni liberi",
    next_shift: "Il tuo prossimo turno",
    shift_not_found: "Nessuno strato trovato",
    show_shift_plan: "Visualizza questo orario dei turni",
    no_shift_place: "Nessuna località specificata",
    no_shifts_assigned: "Attualmente non sei assegnato a nessun turno",
    free_shifts_unavailable: "Attualmente non sono disponibili turni gratuiti",
    filter_shift_plans: "Orari di turno dei filtri",
    no_shift_plans_available: "Non sono disponibili orari di turno",
    filter_locations: "Posti di filtro",
    no_locations_available: "Nessun posto disponibile",
    no_plan_selected: "Nessun orario di turni selezionato",
    no_shifts_for_plan: "Non sono stati trovati strati per questo piano",
    no_shifts_for_location: "Nessun cambiamento riscontrato per la posizione selezionata",
    unknown_shift_plan: "Orario dei turni sconosciuto",
    unknown_location: "Posizione sconosciuta",
    loading_more_shifts: "Carica più strati..."
  },
  clockin_reminder_title: "Già al lavoro? 🔔",
  clockin_reminder: "Ricordati di timbrare il cartellino.",
  clockout_reminder_title: "Sei già alla fine della giornata? 🔔",
  clockout_reminder: "Non dimenticare di timbrare l'uscita.",
  choose_clockin_reminder_time: "Ora del promemoria per timbrare il cartellino",
  choose_clockout_reminder_time: "Ora del promemoria per timbrare l'uscita",
  choose_break_reminder_time: "Durata della pausa",
  saved_successfully: "Salvata 👍 con successo",
  clock_reminder_channel_name: "Promemoria dei francobolli",
  clock_reminder_channel_description: "Promemoria per timbrare l'ingresso e l'uscita",
  break_reminder_title: "Stai ancora facendo una pausa? ⏰",
  break_reminder: "Nota: il tuo tempo di pausa sta ancora scadendo.",
  // Video component translations
  video_not_supported: "Il tuo dispositivo non supporta il video :/",
  video_loading_error: "Video di caricamento errore",
  video_retry: "Ricarica"
};